module.exports = __webpack_public_path__ + "static/media/contact_card.77b3f84a.svg";